(ns manage.ad-variant.creation.entry-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["src/svg/wpp/content-actions/upload.svg$default" :as Upload]
            ["src/svg/wpp/content/fluid-workflow.svg$default" :as FluidWorkflow]
            ["src/svg/wpp/files/spreadsheet.svg$default" :as Spreadsheet]
            [common.flags :refer [use-flag]]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.card :as card]
            [manage.ad-variant.creation.manual-upload-ocp.hooks :as manual-upload.h]
            [manage.adset.hooks :as adset.h]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$]]
            [uix.re-frame :refer [use-subscribe]]))

(defn creation-workflows [project-linking-available? manual-upload-available?]
  (->> [(when project-linking-available?
          {:id :link
           :title "Link with Assemble"
           :description "Connect this Adset to a campaign in WPP Creative Studio's Assemble
                         and ensure Ads produced by WPP's production teams automatically become
                         available for (dynamic) activation"
           :icon ($ FluidWorkflow)})
        (when manual-upload-available?
          {:id :manual
           :title "Upload ad variants"
           :description "Upload existing ads already produced for dynamic activation.
                         Ideal when creative content is already produced."
           :icon ($ Upload)})
        {:id :feed
         :title "Build dynamic ad variants"
         :description "Build dynamic ads in-platform using a single template connected to
                       a content feed, automatically creating, updating, and reviewing ads
                       as content is added or changed."
         :icon ($ Spreadsheet)}]
       (remove nil?)))

(defocp create-ad-variants-entry ::create-ad-variants-entry
  {:width "50%"}
  []
  (let [url-context (use-subscribe [:url-context])
        adset (adset.h/use-adset)
        production-studio-adsets-enabled (use-flag :production-studio-adsets)
        project-linking-available? (and (use-subscribe [:common.os/enabled])
                                        production-studio-adsets-enabled)
        manual-upload-available? (manual-upload.h/use-manual-upload-enabled? adset)
        [creation-workflow set-creation-workflow] (uix/use-state :feed)]
    ($ ocp
       {:title "Create ad variants"
        :footer ($ Stack
                   {:direction "row"
                    :justifyContent "flex-end"
                    :gap 1}
                   ($ Button
                      {:variant "text"
                       :sx #js {:color "text.primary"}
                       :onClick #(rf/dispatch [:ocp/close])}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :type "submit"}
                      "Next"))
        :on-submit (fn []
                     (rf/dispatch [:ocp/close])
                     (case creation-workflow
                       :feed (r.easy/navigate :adset/ad-variants-creation {:path-params url-context})
                       :link (rf/dispatch [:ocp/open {:id :ad-variants-link-ocp}])
                       :manual (rf/dispatch [:modal/open {:id :ad-variants/manual-upload-modal}])))}
       ($ Stack {:gap 3}
          ($ :span "How would you like to add ads?")
          (for [{:keys [id title description icon disabled]} (creation-workflows project-linking-available? manual-upload-available?)]
            ($ card/selectable
               {:key id
                :id id
                :value creation-workflow
                :onChange set-creation-workflow
                :title title
                :icon icon
                :disabled disabled
                :sx #js {".MuiCardHeader-avatar" #js {:mr 1}}}
               description))))))
